import { createFileRoute } from "@tanstack/react-router";
import HowToGetMentalHealthHelpPage from "@/pages/articles/HowToGetMentalHealthHelpPage";
export const Route = createFileRoute("/how-to-get-mental-health-help")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "How to Get Mental Health Help | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How to get mental health help for depression: where to start, what to ask, and treatment options like TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "How to Get Mental Health Help | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How to get mental health help for depression: where to start, what to ask, and treatment options like TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/how-to-get-mental-health-help",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/how-to-get-mental-health-help",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <HowToGetMentalHealthHelpPage />;
}
